import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import {
  fetchPlatformStockLogs,
  fetchPlatformStocks,
  type FetchPlatformStocksParams,
} from './platform-stocks.queries'
import { keys } from './keys'

export const getPlatformStocksOptions = (params?: FetchPlatformStocksParams) =>
  queryOptions({
    queryKey: keys.platformStocks.list(params),
    queryFn: () => fetchPlatformStocks(params),
    placeholderData: keepPreviousData,
  })

export const getPlatformStockLogsOptions = (id: number) =>
  queryOptions({
    queryKey: keys.platformStocks.logs(id),
    queryFn: () => fetchPlatformStockLogs(id, 3),
  })

export const getAllPlatformStockLogsOptions = (id: number) =>
  queryOptions({
    queryKey: keys.platformStocks.allLogs(id),
    queryFn: () => fetchPlatformStockLogs(id),
  })
